import * as React from 'react'

const Organization = (props: { className?: string }) => (
  <svg
    className={props.className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.2 6.02606C4.00291 6.02606 4.64873 5.32788 4.64873 4.46762C4.64873 3.60736 4.00291 2.90918 3.2 2.90918C2.39709 2.90918 1.74546 3.60736 1.74546 4.46762C1.74546 5.32788 2.39709 6.02606 3.2 6.02606ZM3.2 7.27282C2.13527 7.27282 0 7.84632 0 8.9871V10.3897H6.4V8.9871C6.4 7.84632 4.26473 7.27282 3.2 7.27282Z'
      fill='#8C97A2'
    />
    <path
      d='M11.3054 2.87677H8.5658L9.67295 1.73737C8.56984 0.646465 6.78386 0.606061 5.68076 1.69697C5.09082 1.13535 5.68046 1.69697 5.09082 1.13535C6.5091 -0.266667 8.784 -0.266667 10.2023 1.13535L11.3054 0V2.87677Z'
      fill='#8C97A2'
    />
    <path
      d='M5.09062 13.091H7.83019L6.72305 14.2304C7.82615 15.3213 9.61213 15.3617 10.7152 14.2708C11.3052 14.8324 10.7155 14.2708 11.3052 14.8324C9.8869 16.2344 7.612 16.2344 6.19372 14.8324L5.09062 15.9678V13.091Z'
      fill='#8C97A2'
    />
    <path
      d='M12.6546 7.48016C13.4575 7.48016 14.1033 6.78198 14.1033 5.92172C14.1033 5.06146 13.4575 4.36328 12.6546 4.36328C11.8517 4.36328 11.2 5.06146 11.2 5.92172C11.2 6.78198 11.8517 7.48016 12.6546 7.48016ZM12.6546 8.72692C11.5899 8.72692 9.45459 9.30042 9.45459 10.4412V11.8438H15.8546V10.4412C15.8546 9.30042 13.7193 8.72692 12.6546 8.72692Z'
      fill='#8C97A2'
    />
  </svg>
)

export default Organization



// WEBPACK FOOTER //
// ./src/components/icons/organizations/Organization.tsx